import { ADS_ACTION_TYPES } from "./constants";
import { BYOK_PROVIDERS, BYOK_PROVIDERS_BY_ID } from "./byokProviderCatalog";

export { BYOK_PROVIDERS, BYOK_PROVIDERS_BY_ID };

/** Mirrors backend BYOK action → provider requirements. */
export const BYOK_PROVIDERS_BY_ACTION_TYPE = {
  [ADS_ACTION_TYPES.GENERATE_TEXT]: ["openai", "google"],
  [ADS_ACTION_TYPES.GENERATE_AD_TEXT]: ["openai", "google", "anthropic"],
  [ADS_ACTION_TYPES.GENERATE_CAMPAIGN]: ["openai", "google", "anthropic"],
  [ADS_ACTION_TYPES.CREATIVES]: ["openai", "google", "anthropic"],
  [ADS_ACTION_TYPES.MESSAGES]: ["openai", "google", "anthropic"],
  [ADS_ACTION_TYPES.VIDEOS]: ["openai", "google", "anthropic", "fal", "heygen"],
  [ADS_ACTION_TYPES.ANIMATE_IMAGE]: ["openai", "fal"],
  [ADS_ACTION_TYPES.ANALYZE_IMAGE_LAYERS]: ["fal"],
  [ADS_ACTION_TYPES.GENERATE_CUSTOM_REPORT]: ["openai", "anthropic"],
};

export const getByokProvidersForActionType = (actionType) => {
  const providerIds = BYOK_PROVIDERS_BY_ACTION_TYPE[actionType];
  if (!providerIds?.length) return [];

  return providerIds.map((id) => BYOK_PROVIDERS_BY_ID[id]).filter(Boolean);
};

export const isByokProviderConfigured = (
  providerId,
  configuredProviders = {}
) => Boolean(configuredProviders?.[providerId]);

export const isByokConfirmBlocked = ({
  paymentMode,
  actionType,
  configuredProviders = {},
}) => {
  if (paymentMode !== "byok" || !actionType) return false;

  const providersForAction = getByokProvidersForActionType(actionType);
  if (!providersForAction.length) return false;

  return !providersForAction.every((provider) =>
    isByokProviderConfigured(provider.id, configuredProviders)
  );
};
